<template>
    <div class="apprentice-simple-card">
        <design-2021-school-settings-settings-component
            :settings-in="settingsIn"
            :disabled-in="disabled"
            :google-drive-in="googleDriveIn"
            :sharepoint-in="sharepointIn"
        ></design-2021-school-settings-settings-component>
    </div>
</template>

<script>
export default {
    name: "design-2021-management-settings-component",
    props: [
        'settingsIn',
        'googleDriveIn',
        'sharepointIn',
    ],
    data(){
        return{
            disabled: true
        }
    }
}
</script>

<style scoped>

</style>
